// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Angular Material Dialog Styles ──────────────────── */

mat-dialog-content {
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
  flex-shrink: 0;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center;
  gap: 12px;
}
 
mat-dialog-actions button {
  width: auto !important;
  display: inline-flex;
}

/* Search Criteria */
.search-criteria {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 8px;
}
.checkbox-group {
  display: flex;
  align-items: flex-end;
  padding-bottom: 2px;
}
/* Search Button */
.search-button-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 8px;
  margin-bottom: 10px;
}

.error-message {
  color: #E21836;
  font-size: 14px;
}

/* Results Section */
.results-section {
  flex: 1;
  border: 1px solid #fff;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 200px;
}

.results-toolbar,
.results-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background-color: #f8f9fb;
  border-bottom: 1px solid #DBDCDD;
}

.results-footer {
  border-bottom: 0;
  border-top: 1px solid #DBDCDD;
}

.results-summary,
.page-indicator {
  color: #333;
  font-size: 13px;
}

.results-pagination-controls,
.pagination {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-button {
  min-width: 96px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #9eb6cf;
  border-radius: 4px;
  background-color: #fff;
  color: #0066b2;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.pagination-button::before,
.pagination-button::after {
  content: none !important;
}

.pagination-button__arrow {
  font-size: 15px;
  line-height: 1;
}

.pagination-button:hover:not(:disabled),
.pagination-button:focus-visible:not(:disabled) {
  background-color: #e8f1fb;
  border-color: #0066b2;
  color: #004a80;
  box-shadow: 0 0 0 2px rgba(0, 102, 178, 0.15);
}

.pagination-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f4f6f8;
  border-color: #c8d1da;
  color: #7c8a97;
}

.page-size-select {
  min-width: 88px;
  height: 32px;
  padding: 4px 8px;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.results-table thead {
  background-color: #0066B2;
  color: #fff;
  display: block;
  flex-shrink: 0;
}

.results-table thead tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.results-table tbody {
  display: block;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.results-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  cursor: pointer;
  border-bottom: 1px solid #fff;
}

.results-table th {
  padding: 8px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #DBDCDD;
  font-size: 14px;
  color: #fff;
}

.results-table td {
  padding: 8px;
  font-size: 14px;
  color: #000;
}

.no-results,
.loading-results {
  text-align: center;
  color: #8C8F93;
  font-style: italic;
  padding: 15px !important;
  font-size: 14px;
}

.loading-results {
  color: #0066b2;
}

/* Responsive */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  mat-dialog-content {
    min-width: 300px;
  }

  .results-toolbar,
  .results-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/cispro-search/cispro-search.component.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;EACd,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,OAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yGAAyG;AAC3G;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* ── Angular Material Dialog Styles ──────────────────── */\n\nmat-dialog-content {\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n  flex-shrink: 0;\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: center;\n  gap: 12px;\n}\n \nmat-dialog-actions button {\n  width: auto !important;\n  display: inline-flex;\n}\n\n/* Search Criteria */\n.search-criteria {\n  margin-bottom: 10px;\n  flex-shrink: 0;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  margin-bottom: 8px;\n}\n.checkbox-group {\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 2px;\n}\n/* Search Button */\n.search-button-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n\n.error-message {\n  color: #E21836;\n  font-size: 14px;\n}\n\n/* Results Section */\n.results-section {\n  flex: 1;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n}\n\n.results-toolbar,\n.results-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  background-color: #f8f9fb;\n  border-bottom: 1px solid #DBDCDD;\n}\n\n.results-footer {\n  border-bottom: 0;\n  border-top: 1px solid #DBDCDD;\n}\n\n.results-summary,\n.page-indicator {\n  color: #333;\n  font-size: 13px;\n}\n\n.results-pagination-controls,\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pagination-button {\n  min-width: 96px;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #9eb6cf;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #0066b2;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pagination-button::before,\n.pagination-button::after {\n  content: none !important;\n}\n\n.pagination-button__arrow {\n  font-size: 15px;\n  line-height: 1;\n}\n\n.pagination-button:hover:not(:disabled),\n.pagination-button:focus-visible:not(:disabled) {\n  background-color: #e8f1fb;\n  border-color: #0066b2;\n  color: #004a80;\n  box-shadow: 0 0 0 2px rgba(0, 102, 178, 0.15);\n}\n\n.pagination-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #f4f6f8;\n  border-color: #c8d1da;\n  color: #7c8a97;\n}\n\n.page-size-select {\n  min-width: 88px;\n  height: 32px;\n  padding: 4px 8px;\n}\n\n.results-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.results-table thead {\n  background-color: #0066B2;\n  color: #fff;\n  display: block;\n  flex-shrink: 0;\n}\n\n.results-table thead tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.results-table tbody {\n  display: block;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.results-table tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  cursor: pointer;\n  border-bottom: 1px solid #fff;\n}\n\n.results-table th {\n  padding: 8px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 2px solid #DBDCDD;\n  font-size: 14px;\n  color: #fff;\n}\n\n.results-table td {\n  padding: 8px;\n  font-size: 14px;\n  color: #000;\n}\n\n.no-results,\n.loading-results {\n  text-align: center;\n  color: #8C8F93;\n  font-style: italic;\n  padding: 15px !important;\n  font-size: 14px;\n}\n\n.loading-results {\n  color: #0066b2;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  mat-dialog-content {\n    min-width: 300px;\n  }\n\n  .results-toolbar,\n  .results-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
